import * as React from 'react'

function CardHandIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={120} height={120} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={30} y={23.333} width={70} height={48.333} rx={4} fill='url(#prefix__paint0_linear_2478_47931)' />
      <rect x={39.906} y={40.727} width={13.209} height={9.039} rx={2} fill='#fff' fillOpacity={0.9} />
      <rect x={40.057} y={58.804} width={9.907} height={6.026} rx={3.013} fill='#fff' fillOpacity={0.9} />
      <rect x={53.266} y={58.804} width={9.907} height={6.026} rx={3.013} fill='#fff' fillOpacity={0.9} />
      <rect x={66.475} y={58.804} width={9.907} height={6.026} rx={3.013} fill='#fff' fillOpacity={0.9} />
      <rect x={79.684} y={58.804} width={9.907} height={6.026} rx={3.013} fill='#fff' fillOpacity={0.9} />
      <g filter='url(#prefix__filter0_bi_2478_47931)' fillRule='evenodd' clipRule='evenodd'>
        <path
          d='M23 61.666a3 3 0 00-3 3v27.648a3 3 0 003 3h8.944a3 3 0 003-3v-3.377c1.975 1.455 4.33 2.688 6.83 3.846 5.99 2.776 14.223 4.262 18.341 3.8 4.118-.463 24.714-14.442 26.212-16.755 1.497-2.313-2.348-3.187-3.845-3.187-.593 0-2.987 1.108-5.942 2.474-4.512 2.088-10.334 4.78-13.049 5.06-3.594.37-11.234-4.347-13.855-6.197 2.995 0 11.323-.45 12.59-.926 1.632-.613 2.321-4.164 1.263-4.164-4.256 0-9.105-1.59-13.611-3.07-3.912-1.283-7.566-2.482-10.35-2.482-1.207 0-2.911.224-4.584 1.03v-3.7a3 3 0 00-3-3H23z'
          fill='#535353'
          fillOpacity={0.3}
        />
        <path
          d='M23 61.666a3 3 0 00-3 3v27.648a3 3 0 003 3h8.944a3 3 0 003-3v-3.377c1.975 1.455 4.33 2.688 6.83 3.846 5.99 2.776 14.223 4.262 18.341 3.8 4.118-.463 24.714-14.442 26.212-16.755 1.497-2.313-2.348-3.187-3.845-3.187-.593 0-2.987 1.108-5.942 2.474-4.512 2.088-10.334 4.78-13.049 5.06-3.594.37-11.234-4.347-13.855-6.197 2.995 0 11.323-.45 12.59-.926 1.632-.613 2.321-4.164 1.263-4.164-4.256 0-9.105-1.59-13.611-3.07-3.912-1.283-7.566-2.482-10.35-2.482-1.207 0-2.911.224-4.584 1.03v-3.7a3 3 0 00-3-3H23z'
          fill='url(#prefix__paint1_linear_2478_47931)'
        />
      </g>
      <defs>
        <linearGradient
          id='prefix__paint0_linear_2478_47931'
          x1={17.23}
          y1={18.424}
          x2={108.233}
          y2={71.289}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#46C8E0' />
          <stop offset={1} stopColor='#52D878' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_2478_47931'
          x1={93.717}
          y1={88.687}
          x2={9.718}
          y2={56.101}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.458} stopColor='#969696' stopOpacity={0} />
          <stop offset={1} stopColor='#36E0FF' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_2478_47931'
          x={14}
          y={55.666}
          width={78.667}
          height={47}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={3} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_2478_47931' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_2478_47931' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_2478_47931' />
        </filter>
      </defs>
    </svg>
  )
}

export default CardHandIcon
